/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popLuckyboxRecords.vue?vue&type=template&id=5a902332&scoped=true"
import script from "./popLuckyboxRecords.vue?vue&type=script&lang=js"
export * from "./popLuckyboxRecords.vue?vue&type=script&lang=js"
import style0 from "./popLuckyboxRecords.vue?vue&type=style&index=0&id=5a902332&prod&lang=scss&scoped=true"
import style1 from "./popLuckyboxRecords.vue?vue&type=style&index=1&id=5a902332&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a902332",
  null
  
)

export default component.exports